import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { Fuel } from './Fuels.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/fuels`;

export async function listFuels(): Promise<PageResult<Fuel>> {
  const result = (await api.get(`${CONTROLLER_URL}`, null)) as unknown;

  return result as PageResult<Fuel>;
}
